
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetopanhalafortcabservice() {



    const cardData =
    {
        keyword: 'Pune to Panhala Fort Cab Services',
        heading: 'S9 Travels: Pune to Panhala Fort Cab Services',
        headingDescription: 'S9 Travels offers comfortable, reliable, and affordable cab services from Pune to Panhala Fort. If you are looking to explore history, nature, and scenic beauty, Panhala Fort is the perfect destination. Located approximately 230 km from Pune, the journey takes around 5 to 6 hours by road. With our well-maintained fleet and professional drivers, you can enjoy a smooth and hassle-free journey, ensuring a comfortable experience throughout.',

        top: 'Top Places to Visit in Panhala with S9 Travels',

       "topPlaces": [
    {
      "title": "Panhala Fort",
      "description": "Panhala Fort, one of the most significant hill forts in Maharashtra, is known for its rich history and stunning views. It was once the stronghold of Chhatrapati Shivaji Maharaj and offers a glimpse into the glorious past of the Maratha Empire. The fort has impressive architecture, ancient structures, and beautiful surroundings."
    },
    {
      "title": "Sajja Kothi",
      "description": "Sajja Kothi is a historic site within Panhala Fort, known for its association with Chhatrapati Shivaji Maharaj. The building is said to be the place where he stayed during his time at the fort, offering a peaceful atmosphere and panoramic views of the surrounding landscapes."
    },
    {
      "title": "Jali Mari",
      "description": "Jali Mari is an ancient water reservoir located near Panhala Fort. The structure is an engineering marvel, built to store water for the fort's inhabitants. It is surrounded by lush greenery and offers a serene environment for a peaceful visit."
    },
    {
      "title": "Someshwar Temple",
      "description": "Someshwar Temple is a beautiful and ancient temple dedicated to Lord Shiva. The temple, located near Panhala Fort, is known for its intricate carvings and peaceful atmosphere, making it a perfect spot for spiritual reflection."
    },
    {
      "title": "Mahalaxmi Temple",
      "description": "The Mahalaxmi Temple in Panhala is dedicated to Goddess Mahalaxmi, the goddess of wealth and prosperity. The temple is a peaceful place for worship and is located in a scenic environment, offering a tranquil visit for pilgrims and tourists alike."
    },
    {
      "title": "Panhala Hill Viewpoints",
      "description": "Panhala Fort offers numerous viewpoints with stunning views of the surrounding valleys, hills, and the nearby towns. The viewpoints are ideal for photography, nature walks, and enjoying the serene beauty of the Western Ghats."
    },
    {
      "title": "Teen Darwaza",
      "description": "Teen Darwaza is an ancient triple gate located at the entrance of Panhala Fort. The gates are an architectural masterpiece, showcasing the fort's historic significance and providing a glimpse into the fortification techniques used in the past."
    },
    {
      "title": "Bhogwati Lake",
      "description": "Bhogwati Lake is a picturesque and peaceful spot near Panhala Fort. The lake is surrounded by lush greenery and offers a tranquil setting for picnics, nature walks, and photography, making it an excellent spot to relax and unwind."
    },
    {
      "title": "Parashar Caves",
      "description": "The Parashar Caves, located near Panhala, are ancient rock-cut caves known for their historical and religious significance. The caves are peaceful and offer an opportunity to explore the region’s history and natural beauty."
    }
],

         "services": [
    {
      "name": "Book Pune to Panhala Fort Taxi",
      "description": "S9 Travels offers comfortable and reliable taxi services from Pune to Panhala Fort. Whether you're visiting for a historical tour or a relaxing getaway, we ensure a smooth and enjoyable journey."
    },
    {
      "name": "Book Pune to Panhala Fort Cab Booking",
      "description": "For a hassle-free ride, book your Pune to Panhala Fort cab with S9 Travels. We provide easy booking options and well-maintained vehicles to ensure your trip is comfortable and convenient."
    },
    {
      "name": "Pune to Panhala Fort One-Way Taxi",
      "description": "Book a one-way taxi from Pune to Panhala Fort with S9 Travels. Our one-way service allows you to travel directly to the fort, offering a convenient and cost-effective option for your journey."
    },
    {
      "name": "Pune to Panhala Fort Round Trip",
      "description": "S9 Travels offers flexible round-trip taxi services from Pune to Panhala Fort. Enjoy a comfortable and punctual journey with professional drivers, ensuring a smooth ride both ways."
    },
    {
      "name": "Pune to Panhala Fort Taxi Service",
      "description": "S9 Travels provides reliable taxi services from Pune to Panhala Fort. Our experienced drivers and well-maintained vehicles ensure a safe and comfortable journey to one of the most historical forts in Maharashtra."
    },
    {
      "name": "Pune to Panhala Fort Cab Fare",
      "description": "We offer transparent and affordable taxi fares for your trip to Panhala Fort. S9 Travels ensures no hidden charges, giving you peace of mind when planning your journey."
    },
    {
      "name": "Pune to Panhala Fort Car Rental",
      "description": "S9 Travels offers car rental services for your trip to Panhala Fort from Pune. Choose from a variety of vehicles for a customized travel experience that suits your preferences and budget."
    },
    {
      "name": "Pune to Panhala Fort Luxury Taxi",
      "description": "For a premium experience, book a luxury taxi from Pune to Panhala Fort with S9 Travels. Enjoy extra space, comfort, and a smooth journey as you explore the scenic beauty and historical significance of Panhala Fort."
    },
    {
      "name": "Pune to Panhala Fort Efficient Taxi",
      "description": "S9 Travels provides Efficient Taxi services from Pune to Panhala Fort, making it an affordable option for budget-conscious travelers. Share the ride with others and enjoy the scenic route at a fraction of the cost."
    },
    {
      "name": "Panhala Fort Cab from Pune",
      "description": "Looking for a taxi to Panhala Fort? S9 Travels offers dedicated Panhala Fort cabs from Pune, ensuring a comfortable and timely journey to this historic location."
    },
    {
      "name": "Affordable Panhala Fort Taxi",
      "description": "S9 Travels offers affordable taxi services from Pune to Panhala Fort. Travel in comfort without breaking the bank with our competitive pricing and no hidden fees."
    },
    {
      "name": "Pune to Panhala Fort Road Trip",
      "description": "Enjoy a scenic road trip to Panhala Fort with S9 Travels. Our drivers are familiar with the best routes to make your journey not only comfortable but also scenic and enjoyable."
    },
    {
      "name": "Private Panhala Fort Tour from Pune",
      "description": "For a personalized and private journey, book a private Panhala Fort tour from Pune with S9 Travels. We provide a dedicated driver and well-maintained vehicle, ensuring a relaxing and private experience."
    },
    {
      "name": "Panhala Fort Car Hire",
      "description": "S9 Travels offers car hire services for your trip to Panhala Fort from Pune. Whether you're planning a solo trip or a group journey, we have the perfect vehicle for your needs."
    }
],

"tableData": [
  ["Book Pune To Panhala Fort Taxi", "Book Pune To Panhala Fort Cab Booking"],
  ["Book Pune To Panhala Fort One-Way Taxi", "Book Pune To Panhala Fort Round Trip"],
  ["Book Pune To Panhala Fort Taxi Service", "Book Pune To Panhala Fort Cab Fare"],
  ["Book Pune To Panhala Fort Car Rental", "Book Pune To Panhala Fort Luxury Taxi"],
  ["Book Pune To Panhala Fort Efficient Taxi", "Panhala Fort Cab from Pune"],
  ["Affordable Panhala Fort Taxi", "Pune to Panhala Fort Road Trip"],
  ["Private Panhala Fort Tour from Pune", "Panhala Fort Car Hire"]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand that your visit to Panhala Fort deserves to be seamless and stress-free. Our drivers ensure timely pickups and drop-offs, so you can enjoy your trip to this historical site without any delays or concerns."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a variety of well-maintained vehicles, including sedans, SUVs, and premium cars, for your journey from Pune to Panhala Fort. Our vehicles are designed for comfort with spacious interiors, air conditioning, and ample luggage space, ensuring a smooth and relaxing ride."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced and knowledgeable about the routes leading to Panhala Fort. They prioritize your safety, comfort, and convenience, ensuring a smooth and secure journey as you travel through scenic landscapes to reach this historic destination."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels provides competitive and transparent pricing for your Pune to Panhala Fort trip. We offer a clear breakdown of costs with no hidden charges, ensuring that you know exactly what to expect and can enjoy your journey without any surprises."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features, such as airbags, seat belts, and GPS tracking, ensuring a secure and comfortable journey. You can relax and enjoy the historical beauty of Panhala Fort knowing that we have taken every step to ensure your safety."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "Whether you're planning an early morning trip or a late-night return, S9 Travels is available around the clock. Our customer service team is always ready to assist you with bookings, trip planning, and any inquiries you may have."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking a cab for your Pune to Panhala Fort journey is easy and convenient with S9 Travels. You can book online through our website or mobile app, or you can contact our customer service team for personalized assistance with your booking."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you're visiting Panhala Fort for historical exploration or simply to enjoy its scenic views, we offer customized travel packages that suit your preferences. Let us know your requirements, and we’ll tailor your trip to make it special and memorable."
  }
]


















    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Panhala Fort cab with S9 Travels?',
            answer: 'Booking is simple! You can book online through our website or app, or contact our customer service team for personalized assistance with your booking.',
          },
          {
            question: 'What types of vehicles are available for the Pune to Panhala Fort trip?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and premium cars. All our vehicles are well-maintained to provide you with comfort and safety during your journey.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel to Panhala Fort?',
            answer: 'Yes, all our drivers are experienced in driving long distances and are familiar with the best routes to Panhala Fort. They ensure a smooth and enjoyable journey.',
          },
          {
            question: 'How do I pay for my Pune to Panhala Fort cab rental?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments via our app, making it easy and convenient for you to pay for your ride.',
          },
          {
            question: 'Can I book a round-trip from Pune to Panhala Fort?',
            answer: 'Yes, we can arrange a round-trip for you. Simply provide us with your return details, and we’ll ensure a smooth and comfortable return journey.',
          },
          {
            question: 'Are there any extra charges for waiting or detours during the trip?',
            answer: 'Any additional charges for waiting time or detours will be communicated to you upfront before your trip, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Panhala Fort?',
            answer: 'Yes, we offer sightseeing services around Panhala Fort. Explore the fort\'s historical significance, scenic views, and nearby attractions with the help of our experienced drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Panhala Fort cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional luggage or special requirements, please inform us during the booking process, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate or group travel to Panhala Fort?',
            answer: 'Yes, we offer corporate and group travel services to Panhala Fort. Whether it\'s a corporate trip or a family outing, we ensure a safe, comfortable, and enjoyable journey for everyone.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Panhala Fort journey?',
            answer: 'S9 Travels guarantees a reliable, comfortable, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. We prioritize your safety and comfort, ensuring a smooth and memorable trip to Panhala Fort.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Sachin Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab with S9 Travels for a trip to Panhala Fort. The vehicle was clean and comfortable, and the driver was friendly and professional. The trip was smooth, and we had a wonderful time exploring the fort. Highly recommend!”',
        },
        {
          name: 'Mrs. Pratima Rao',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family had a great experience with S9 Travels for our visit to Panhala Fort. The driver was knowledgeable about the history of the fort, and the vehicle was spacious and comfortable. A memorable journey!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune To Panhala Fort Cab Service",
        "description": "Book Pune to Panhala Fort cab services with S9 Travels. Whether you're looking for a one-way taxi, round-trip, luxury taxi, or car rental, we offer affordable and reliable transport to Panhala Fort. Book private cabs, Efficient Taxis, or plan a road trip to Panhala Fort for a memorable journey from Pune.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
    
      
      


    return (
        <div>
           <Helmet>
        <title>Pune To Panhala Fort Cab Service | Affordable Taxi & Car Rentals | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune to Panhala Fort taxi services, one-way, round-trip, luxury taxis, Efficient Taxis, and car rentals with S9 Travels. Get the best fares for your Panhala Fort tour, private cab bookings, and road trip plans for a scenic journey from Pune." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/23.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetopanhalafortcabservice;